export default "__VITE_ASSET__BgSJXp6S__"